import { TeacherRouter } from '~teacher/context/RouterContext';

export function libraryOrQuizzes(isDeleted: boolean) {
  return isDeleted ? 'deleted' : 'library';
}

export function createWorkspaceFolderFragment({
  workspaceFolderId,
  workspaceId,
  isDeleted,
}: {
  workspaceFolderId: string;
  workspaceId: string;
  isDeleted: boolean;
}) {
  return `workspaces/${workspaceId}/${libraryOrQuizzes(isDeleted)}${
    workspaceFolderId !== null ? `/${workspaceFolderId}` : ''
  }`;
}

export function navigateByFolderId({
  router,
  workspaceId,
  workspaceFolderId,
  isDeleted,
}: {
  router: TeacherRouter;
  workspaceFolderId: string;
  workspaceId: string;
  isDeleted: boolean;
}) {
  const newFragment = createWorkspaceFolderFragment({
    workspaceId,
    workspaceFolderId,
    isDeleted,
  });
  router.navigate(newFragment, { trigger: true });
}
